import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, ViewContainerRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ShareMultiDropDownData } from '../search-select/multi-select.service';
import { BaseService } from '../../shared/services/base.service';
import { AsyncValidationService } from './async-validation.service';
import { ckConfig } from './models/ck-editor-config.model';
declare var jQuery: any;
import { FormService } from './form.service';
import { CommonService } from '../../services/common.service';
import { UtilService } from '../../services/util.service';
import moment from 'proxies/dayjs';
import { debounce } from 'lodash';
import { DaterangepickerDirective } from '../daterangepicker/daterangepicker.directive';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { TranslateService } from '../../services/translate.service';
import { environment } from 'src/environments/environment';
import { TextToSpeechComponent } from '../text-to-speech/text-to-speech.component';
import { DialogModalSize } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { PreferenceService } from '../../shared/services/preference.service';
import { Subscription } from 'rxjs';
import { FormWithGridComponent } from '../form-with-grid/form-with-grid.component';
@Component({
    selector: 'dhs-form-question',
    templateUrl: './form-question.component.html',
    styleUrls: ['./form-question.component.css'],
    standalone: false
})
export class FormQuestionComponent implements OnInit, OnDestroy {
  private sub: Subscription = new Subscription();
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  // same by-type ViewChild pattern already used above for DaterangepickerDirective; only
  // resolves when this field's controlType is 'formwithgrid' (the *ngSwitchCase in the template)
  @ViewChild(FormWithGridComponent) formWithGridComponent: FormWithGridComponent;
  @Input() index: number = 0; // Use is while plotting controls inside editable grid
  @Input() insideGrid: boolean = false; // On use for editable grid 
  @Input() question: any;
  @Input() maxlength: any;
  @Input() minlength: any;
  @Input() pattern: any;
  @Input() type: any;
  @Input() placeholder: any;
  @Input() config: any = {};
  @Input() form: FormGroup;
  //@Input() change: EventEmitter<any>;
  @Input() action: string;
  @Input() layout_type: any;
  @Input() decorator: any = false;
  //@Output() unsavedData = new Subject();
  //@Output() actionClicked = new EventEmitter<any>();
  @Output() valueChanged = new EventEmitter<any>();
  @Output() customButtonEventFired = new EventEmitter<any>();
  @Output() runTimeQuestions = new EventEmitter<any>();
  @Output() getData: EventEmitter<any> = new EventEmitter();//for outputting general configration
  @Output() setConfig: EventEmitter<any> = new EventEmitter();
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;
  @Input() validIn;
  @Output() multiselectClose = new EventEmitter<any>();
  eye: string = "fa-eye";
  errorMessage: string = 'is required';
  found: boolean = false;
  showFlag: boolean = false;
  isShown: boolean = false;
  recaptchaKey: any;
  macroText: any = {};
  // @ViewChild('textSearchInput', { static: true }) textSearchInput: ElementRef;
  // macro_data: any;
  // macro_type: any;
  ckeConfig: any;
  customCkeConfig: any;
  tooltip_value: string;
  ranges: any = {
    'Today': [moment().startOf('day'), moment().endOf('day')],
    'Yesterday': [moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')],
    'Last 7 Days': [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')],
    'Last 30 Days': [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }
  _moment = moment

  // separator: string;
  /// Selech and select var and @inputs start
  /// Selech and select var and @inputs end
  constructor(
    public MultiDropDownService: ShareMultiDropDownData,
    public baseService: BaseService,
    public async_validation: AsyncValidationService,
    private formService: FormService,
    private dialogService: DialogService,
    public commonService?: CommonService,
    public utilService?: UtilService,
    private cdr?: ChangeDetectorRef,
    public rolePermissionService?: RolePermissionService,
    public translateService?: TranslateService,
    public preferenceService?: PreferenceService
  ) {
    this.macroChangeEvent = debounce(this.macroChangeEvent, 1000);
    // console.log("question in form question component==>>", this.question);
    // this.value = this.question.value;
  }

  ngOnInit() {
    if (this.recaptchaKey == undefined)
      this.recaptchaKey = environment.recaptcha.siteKey;
    // console.log("recaptcha", this.recaptchaKey);
    // if(this.question && this.question.disabled && this.form && this.form.controls && this.question && this.question.key) {
    //   this.form.controls[this.question.key].disable();
    // }
    if (this.question.controlType == "custom_form_component") {
      setTimeout(() => {
        this.customComponent.clear();
        this.baseService.createComponent(this.question.selector, this.customComponent, (callback) => {
          if (callback) {
            callback.instance.form = this.form;
            callback.changeDetectorRef.detectChanges();
          }
        })
      })
    }
    if (this.question.controlType == 'html-editor') {
      if (this.question.customConfig != undefined && this.question.customConfig.fullEditor != undefined && this.question.customConfig.fullEditor) {
        this.ckeConfig = new ckConfig().fullEditorConfig;
      } else {
        this.ckeConfig = new ckConfig().ckConfig;
      }
      if(this.question.maxlength != undefined){
        this.ckeConfig.maxlength = this.question.maxlength;
      }
      this.ckeConfig.readOnly = this.question.disabled != undefined ? this.question.disabled : false;
    }
    if (this.insideGrid && this.form.controls != undefined && this.form.controls[this.question.key] != undefined) {
      this.question.value = this.form.controls[this.question.key].value;
    }
    ///Seach and select code 
    //End seach and select work
    if (this.form != undefined && this.form.controls[this.question.key] != undefined) {
      if (this.question.controlType != undefined && this.question.controlType == 'dropdown' && this.question.datasource != undefined) {
        this.sub.add(this.formService.getOpionChanged().subscribe(x => {
          if(x){
          this.form.controls[this.question.key]['question_component'] = this;
          }
        }));
      }
      else {
        this.form.controls[this.question.key]['question_component'] = this;
      }
    }
    try {
      this.config['form_action'] = this.action;
    } catch (error) {

    }

    //console.log("question in form question component==>>", this.question.controlType, this.question.key,this.form.controls[this.question.key]);
  }

  getAutoData(){
    this.formService.cardData.data.role = this.formService.appService.getRoles().role;
    this.formService.cardData.data.module = this.formService.appService.getApplication();
    this.formService.cardData.data.specialisation = this.form.controls.currentTreatingDoctorSpecialityId.value;
    let datasource = this.question.datasource;
    let obj = {
      "args": this.baseService.buildDyanamicStr(datasource.args, this.formService.cardData),
      "filter": this.baseService.buildDyanamicStr(datasource.filter, this.formService.cardData),
    }
    this.baseService.getData(obj, "", datasource.resource, datasource.application, datasource.query_id).subscribe(
      (data: any) => {
        if(data.errCode == 0 && data.resource && data.resource.length > 0){
          this.question.options = data.resource;
        }
      });
  }

  macroChangeEvent(inputtext: string) {
    this.macroText.separator = "";
    let input = inputtext.split(" ");
    let textEnter = [];
    if (inputtext.includes('\n')) {
      textEnter = input[input.length - 1].split('\n');
    } else if (inputtext.includes('<br>')) {
      textEnter = input[input.length - 1].split('<br>');
    }
    this.macroText.separateText = input[input.length - 1];
    if (textEnter.length) {
      this.macroText.separateText = textEnter[textEnter.length - 1];
    }
    if (this.macroText.separateText.includes("@") && this.macroText.separateText.charAt(0) == '@') {
      this.macroText.separator = "@";
    } else if (this.macroText.separateText.includes("#") && this.macroText.separateText.charAt(0) == '#') {
      this.macroText.separator = "#";
    }
    if (this.macroText.separator != "") {
      let str = this.macroText.separateText.substring(this.macroText.separateText.indexOf(this.macroText.separator) + 1);
      if (this.question && this.question.macro_datasource) {
        let resource = this.question.macro_datasource.resource;
        var obj = {}
        obj = { "search": str }
        let application = this.question.macro_datasource.application;
        let query_id = this.question.macro_datasource.query_id;
        this.baseService.getData(obj, "", resource, application, query_id).subscribe(
          (data: any) => {
            this.macroText.macro_data = data.resource;
            // this.macroText.macro_data.forEach(res => {
            //   this.macroText.macro_type = res.macro_type;
            // });
            // if (separator == "#" || separator == "@") {
            this.isShown = true;
            // }
          });
      }
    } else {
      this.isShown = false;
    }
    this.macroText.currentText = inputtext;
  }

  handler(event) {
    // if (this.macroText.currentText.includes("@") || this.macroText.currentText.includes("#")) {
    //   let str = this.macroText.currentText.split(' ');
    //   str.splice(str.lastIndexOf(this.macroText.separateText), 1, event.target.id);
    //   let currentText = str.join(' ');
    //   // this.question.value = this.currentText;
    //   this.form.controls[this.question.key].setValue(currentText);
    //   this.isShown = false;
    // }
    const text = this.macroText.currentText;
    if (!text.includes('@') && !text.includes('#')) {
      return;
    }
    // Split by space OR newline OR br
    const tokens = text.split(/(<br\s*\/?>|\s+)/gi);

    // keeps spaces/newlines intact

    // find last occurrence of @ or #
    const index = tokens.map(t => t.trim()).lastIndexOf(this.macroText.separateText);

    if (index !== -1) {
      tokens[index] = event.target.id;
    }
    const currentText = tokens.join('');
    this.form.controls[this.question.key].setValue(currentText);
    this.isShown = false;
  }
  macroValue(option, question) {
    if (question && question.macro_datasource && question.macro_datasource.getterValue) {
      if (option.hasOwnProperty(question.macro_datasource.getterValue)) {
        return option[question.macro_datasource.getterValue];
      }
    }
  }
  // macroKey(option, question) {
  //   if (option.hasOwnProperty(question.macro_datasource.getterKey) && option.hasOwnProperty(question.macro_datasource.getterValue)) {
  //     return option[question.macro_datasource.getterKey] + " | " + option[question.macro_datasource.getterValue];
  //   }
  // }

  displayMacro(event) {
    console.log("event ", event);
    this.isShown = false;
    this.cdr.detectChanges();
  }
  onKeydownDate(event, question): void {
    if (!question.enableInput)
      event.preventDefault();
  }

  openDatepicker() {
    this.pickerDirective.open({ button: true });
  }

  getDivClass(question) {
    let className = '';
    if (this.config && !this.config.isTemplate) {
      if (this.layout_type != undefined && this.layout_type == 'no-column' && question.controlType != 'hidden' && question.controlType != 'subHeading') {
        className = question.className;
      }
      else if (question.controlType != undefined && question.controlType == 'daterangepicker' && !question.singleDatePicker) {
        className = 'form-element date_range_input';
      }
      else if ((question.controlType == 'checkbox') && !question.is_label_required && !this.insideGrid) {
        className = 'form-element check-with-no-label';
      }
      else if ((question.controlType == 'checkbox') && question.is_label_required && !this.insideGrid) {
        className = 'form-element check-with-label';
      }
      else if (question.controlType == 'radio' && !this.insideGrid) {
        className = 'form-element radio-with-label form-inline';
      }
      else if (question.controlType == 'edit_grid' || question.controlType == 'editgrid') {
        className = 'form-element full-width';
      }
      else if (question.controlType == 'composite-array') {
        className = 'form-element full-width';
      }
      else if (question.controlType == 'subHeading') {
        className = 'form-subHeading';
      }
      else if (question.controlType == 'button' && question.permission_check && !this.rolePermissionService.checkAccessPermission(question.permission_check['action_name'], question.permission_check['resource'], question.permission_check['application'])) {
        className = '';
      }
      else if (question.controlType != 'hidden' && !this.insideGrid) {
        className = 'form-element';
      }

    }
    else {
      if ((question.controlType == 'checkbox') && question.is_label_required && !this.insideGrid) {
        className = question.className + " template-form-checkbox template-form-field";
      }
      else if ((question.controlType == 'checkbox') && !question.is_label_required && !this.insideGrid) {
        className = question.className + " template-form-checkbox-w-label template-form-field";
      }
      else if ((question.controlType == 'radio') && !this.insideGrid) {
        className = question.className + " template-form-radio template-form-field";
      }
      else if (question.controlType == 'textbox') {
        className = question.className + " template-form-textbox template-form-field";
      }
      else if (question.controlType == 'radio') {
        className = question.className + " template-form-radio template-form-field";
      }
      else if (question.controlType == 'textarea') {
        className = question.className + " template-form-textarea template-form-field";
      }
      else if (question.controlType == 'annotation') {
        className = question.className + " template-form-annotation template-form-field";
      }
      else if (question.controlType == 'numberbox') {
        className = question.className + " template-form-numberbox template-form-field";
      }
      else if (question.controlType == 'daterangepicker') {
        className = question.className + " template-form-daterangepicker template-form-field";
      }
      else if (question.controlType == 'timepicker') {
        className = question.className + " template-form-timepicker template-form-field";
      }
      else if (question.controlType == 'html-editor') {
        if (!this.isValid)
          className = question.className + " template-form-htmleditor template-form-field editor-error";
        else
          className = question.className + " template-form-htmleditor template-form-field";
      }
      else if (question.controlType == 'dynamic-table') {
        className = question.className + " template-form-radio template-form-field";
      }
      else if (question.controlType == 'rating') {
        if (!this.isValid)
          className = question.className + " template-form-dynamictable template-form-field rating-error";
        else
          className = question.className + " template-form-dynamictable template-form-field";
      }
      else if (question.controlType == 'score') {
        if (!this.isValid)
          className = question.className + " template-form-score template-form-field score-error";
        else
          className = question.className + " template-form-score template-form-field";
      }
      else if (question.controlType == 'searchselect') {
        className = question.className + " template-form-searchselect template-form-field";
      }
      else if (question.controlType == 'inputSearch') {
        className = question.className + " template-form-inputSearch template-form-field";
      }
      else if (question.controlType == 'subHeading') {
        className = question.className + " template-form-subHeading template-form-field";
      }
      else if (question.controlType == 'dropdown') {
        className = question.className + " template-form-dropdown template-form-field";
      }
      else if (question.controlType == 'single-choice-question') {
        className = question.className + " template-form-dropdown";
      }
      else if (question.controlType == 'pullable') {
        if (!this.isValid)
          className = question.className + " template-form-pullable template-form-field pullable-error";
        else
          className = question.className + " template-form-pullable template-form-field";
      }
      else if (question.controlType == 'tickets') {
        if (!this.isValid)
          className = question.className + " template-form-dynamictable template-form-field rating-error";
        else
          className = question.className + " template-form-dynamictable template-form-field";
      }
      else {
        className = question.className + " template-form-field";
      }
    }
    if (question.controlType !== 'hidden' && question.controlType !== 'composite-array' && !this.isValid) {
      if (question.controlType == 'dropdown' || question.controlType == 'searchselect')
        className += ' error dd-error';
      else if (question.controlType == 'daterangepicker' && question.disabled != undefined && question.disabled == false)
        className += ' error dt-error';
      else if (question.controlType == 'timepicker')
        className += ' error tp-error';
      else if (question.controlType == 'edit_grid' || question.controlType == 'editgrid' || question.controlType == 'composite-array')
        className += ' full-width error';
      else if (question.controlType == 'password')
        className += ' eye-error error';
      else if (question.controlType == 'fileuploader')
        className += ' fu-error error';
      else if (question.disabled != undefined && question.disabled == true)
        className += '';
      else
        className += ' error';
    }

    if (question.controlType == 'textbox' && question.asideButton != undefined && question.asideButton.expression != undefined && this.checkExpression(question.asideButton.expression)) {
      className = className + " flex_display";
    } else if (question.controlType == 'textbox' && question.text_buttonIcon != undefined) {
      className = className + " form-inline";
    }

    return className;
  }

  onKeyupNumberEvent(e, question) {
    if (question.value === "" && e.target.value === "" && question.setDefault != undefined && !question.setDefault) {
      if (document.getElementById(question.key + this.index)){
        document.getElementById(question.key + this.index)['value'] = "";
      }
      this.form.controls[question.key].setValue("");
    } else if (question.value == 0 && question.valueRemoved == undefined) {
      if (this.action == undefined || this.action == 'ADD' || (this.action == 'MODIFY' && this.form.controls != undefined && this.form.controls[question.key] != undefined && this.form.controls[question.key].value == 0)) {
        if (e.target.value.charAt(0) == 0) {
          let val = +e.target.value.replace(/^0+/, '');
          if (document.getElementById(question.key + this.index)){
            document.getElementById(question.key + this.index)['value'] = val;
            // question.value = val;
          }
          this.form.controls[question.key].setValue(val);
        }
        else if (e.target.value.length > 1 && e.target.value.charAt(1) == 0) {
          let val_ = +e.target.value.substring(0, e.target.value.length - 1);
          if (document.getElementById(question.key + this.index)){
            document.getElementById(question.key + this.index)['value'] = val_;
          }
          // question.value = val_;
          this.form.controls[question.key].setValue(val_);
        }
        question.valueRemoved = true;
      }
    }
  }
  // ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
  //   this.form.valueChanges.subscribe(
  //     data => {
  //       this.unsavedData.next(true);
  //     }
  //   )
  // }
  eventFired(e, question?) {
    if (question != undefined && question.required != undefined && question.required) {
      this.valueChanged.emit({ "button": e.type,"action":e.action,"index":e.index,"items":e.items,"removedItem":e.removedItem, "deletedRow": e.deletedRow});
    } else if (question.controlType == "editable-table") {
      question.value = e.items;
      this.valueChanged.emit({ question: this.question });
    } else if (question.controlType == "inclusion-exclusion") {
      question.value = e.items;
      this.valueChanged.emit({ question: this.question });
    } else {
      this.valueChanged.emit({ 'val': e });
    }
  }

  // getQuestion(question: any) {
  //   return JSON.stringify(question);
  // }

  checkBoxEntity(event) {
    this.question.data = event;
    this.valueChanged.emit({ question: this.question });
  }
  get f() { return this.form.controls; }
  get isValid() {
    /*if form is refreshed or its yet not submitted directly 
    *return true so that error messaeg wont get displayed below every field.
    */
    if ((!this.validIn) && (!this.form.controls[this.question.key].touched)) {
      return true;
    }
    if (this.question['trim']) {
      if (this.form.controls[this.question.key].value)
        this.form.controls[this.question.key].patchValue(this.form.controls[this.question.key].value.trim());
    }
    if (this.question['disabled']) {
      this.form.controls[this.question.key].disable();
    }

    if (this.form.controls[this.question.key].errors && this.form.controls[this.question.key].errors.pattern) {
      if (this.question.cstm_error_msg != undefined) {
        this.errorMessage = this.question.cstm_error_msg;
      }
      else
        this.errorMessage = 'is not in a valid format';
    }
    else if (this.form.controls[this.question.key].errors && this.form.controls[this.question.key].errors.maxlength) {
      this.errorMessage = 'is exceeding the limit of ' + this.question['maxlength'] + ' digits';
    } else if (this.form.controls[this.question.key].errors && this.form.controls[this.question.key].errors.minlength) {
      this.errorMessage = 'must be of ' + this.question['minlength'] + ' digits long';
    } else if (this.found) {
      this.errorMessage = "didn't match";
    } else if (this.showFlag) {
      this.errorMessage = "Already Exist"
    } else {
      this.found = false;
      //assuming that cstm error msg will come in first object this will work as rule
      this.errorMessage = this.question.validations != undefined && this.question.validations.length != undefined && this.question.validations[0].cstm_error_msg != undefined ? this.question.validations[0].cstm_error_msg : 'validation check failed';
    }

    if (this.question['controlType'] == 'checkbox') {
      if (this.question['required'] && (this.form.controls[this.question.key].value == null || this.form.controls[this.question.key].value == false)) {
        this.form.controls[this.question.key].setErrors({ 'incorrect': true });
      }
    }
    if (this.question['controlType'] == 'fileuploader') {
      if (this.question['required'] && (this.question.multiple != undefined && this.question.multiple ? this.form.controls[this.question.key].value.length == 0 : !this.form.controls[this.question.key].value)) {
        this.form.controls[this.question.key].setErrors({ 'incorrect': true });
      }
      else {
        this.form.controls[this.question.key].setErrors(null);
      }
    }

    if (this.question['controlType'] == 'numberbox') {
      if (this.question['required'] && (this.form.controls[this.question.key].value == null || this.form.controls[this.question.key].value === false || (this.question.setDefault === true && this.form.controls[this.question.key].value === 0)) || (this.question.setDefault === false && this.question.min !== null && this.question.min != undefined && this.question.min > this.form.controls[this.question.key].value)) {
        this.form.controls[this.question.key].setErrors({ 'incorrect': true });
      }
    }
    // console.log("this.form.controls[this.question.key].invalid",this.form.controls[this.question.key].invalid);
    if (this.validIn && this.form.controls[this.question.key].invalid) {
      return false;
    }
    //console.log(this.question.key,this.form.controls[this.question.key].valid,this.form.controls[this.question.key].pristine);
    return this.form.controls[this.question.key].valid || this.form.controls[this.question.key].pristine;
  }

  // private onActionClicked(item: any, action: string) {
  //   this.actionClicked.emit({ action, item });
  // }
  // getKey(option, key) {
  //   if (option.hasOwnProperty(key.getterKey)) {
  //     if (key.flag) {
  //       return option;
  //     }
  //     else {
  //       return option[key.getterKey];
  //     }
  //   }
  // }
  // getIdKey(option, key) {
  //   if (option.hasOwnProperty(key.getterKey)) {
  //     return option[key.getterKey];
  //   }
  // }
  getOptionsValue(option, question) {
    if (question.getterKey) {
      return option[question.getterKey];
    } else {
      return option.id;
    }
  }
  getOptionsKey(option, question) {
    var res = "";
    try {
      if (question.getterValue) {
        if (question.format != undefined) {
          let fn;
          if (question.format != undefined && option != undefined && eval(question.format)(option) != undefined) {
            res = eval(question.format)(option);
          }
        } else {
          res = option[question.getterValue];
        }
      } else {
        res = option.value
      }
      if ((question != undefined && question.datasource != undefined && question.datasource.resource != undefined && question.datasource.resource == "valueset") || (question != undefined && question.datasource != undefined && question.datasource.possible_value != undefined)) {
        this.translateService.translate(res).subscribe(x => {
          if (x) {
            res = x;
          }
        });
      }
      return res;
    } catch (error) {
      console.error(error);
    }
  }
  onPaste(e: ClipboardEvent) {
    try {
      var clipboardData = e.clipboardData;
      var pastedText: any = clipboardData.getData('text');
      if (pastedText != "" && isNaN(pastedText)) {
        e.preventDefault();
      }
    } catch (e) {

    }
  }
  getValue(option, question) {
    if (question.format != undefined) {
      if (question.format != undefined && option != undefined && eval(question.format)(option) != undefined) {
        return eval(question.format)(option);
      }
    } else if (option.hasOwnProperty(question.getterValue)) {
      return option[question.getterValue];
    }
  }
  changeEvent(event, key) {

    if (event.target.value == '') {
      this.found = false;
    }
    let data = this.form.controls[key].value
    if (!(data == event.target.value)) {
      this.found = true;
      this.form.controls[event.target.id].setErrors({ 'incorrect': true });
    } else {
      this.found = false;
    }

  }
  checkFieldExistence(event, question) {
    // console.log('Event is ==>>', event.srcElement.id);
    let elemId = String(event.srcElement.id);
    if (question.searchable == true) {
      if (!event.target.value) {
        this.showFlag = false;
      }
      this.async_validation.checkBillExist(event, question).subscribe((res) => {
        // console.log('SetTimeout triggered Api Response form-question.component ==>>', res);
        if (res.resource[0].fieldPresent == true) {
          this.showFlag = true;
          //  document.getElementById(elemId).focus();          
          return false;
        } else {
          this.showFlag = false;
          return true;
        }
      })
    }
  }
  getDataOnDateChange(event) {
    console.log('Event on date change.....', event);
    if (typeof event === 'string') {
      return event;
    } else {
      var date = new Date(event);
      if (isNaN(date.getTime()) && event && event.target && event.target.value && this.question.enableInput && this.question.type == 'long') {
        let dt = new Date(event.target.value).getTime();
        this.form.controls[this.question.key].setValue(dt);
        return dt;
      }
      return date.getTime();
    }
  }
  //this function is written as initially we were using value for binding dropdown we changed it to ngvalue to make our valuechange work we have written this as a adapter
  valueChangeDd(event, question) {

    if (event.target.value == 'paginate') {
      this.form.controls[question.key].setValue("");
      // event.stopPropagation();
      // event.preventDefault();
      let dataSourceFound = question.showMoreDatasource != undefined ? question.showMoreDatasource : question.datasource;
      if (question.datasource.page_size != undefined && question.datasource.page_size) {
        question.datasource.page_size = question.datasource.page_size + 10;
      }
      var getDropdownData = this.formService.getDictionary(dataSourceFound.resource, dataSourceFound.query_id, dataSourceFound.application, dataSourceFound.args ? dataSourceFound.args : null, dataSourceFound.filter ? dataSourceFound.filter : null, question, dataSourceFound.read_scope_level ? dataSourceFound.read_scope_level : undefined).subscribe(data => {
        this.formService.dropdownoptionAdapter(question, data, question);
      })
      return;
    }

    if (event != undefined && event.target != undefined && event.target.value != undefined) {
      let val = "";
      if (event.target.selectedIndex != undefined && event.target.selectedIndex) {
        val = question.options[event.target.selectedIndex - 1][question.getterKey];
      }
      let obj = { target: { value: val, selectedIndex: event.target.selectedIndex } };
      this.valueChange(obj, question);
    }
  }

  emitButtonTo() {
    // this.valueChanged.emit({ type: 'inputBtn' });
    this.valueChanged.emit({ question: this.question, type: 'inputBtn' });
  }


  valueChange(event, question, isManual = true) {
    var val: any;
    //added to stoppropagation in case of populate fields //will not affect other thus no check is added
    this.question['stop_propagation'] = false;
    if (question.controlType == "daterangepicker") {

      //check for manual change flag
      let flag = false;
      //for multi date range picker
      if (event && typeof event == 'object') {
        flag = event[question.startKey] != null && event[question.startKey] != null ? true : false;
      }
      else {
        flag = event != null;
      }
      //________//

      if (flag && this.action != 'SEARCH') {//daterangepicker fires this function automatically with null value, we want to  avoid that
        this.form["_manualChange"] = true;
      }
    } else {
      // question.controlType != "editgrid" this is added as manual change should be fired only when user makes any change but in case of editable grid update happens thus valuechange gets fired 
      if (isManual && question.controlType != "editgrid") {
        this.form["_manualChange"] = true;
      }
    }

    if (event && question.controlType == "daterangepicker") {
      val = this.getDataOnDateChange(event);
    }

    if (question.controlType == "textbox" && question.type == 'date') {
      if (event.keyCode == 8 || event.keyCode == 46) {
        event.target.value = event.target.value.substring(0, event.target.value.length);
      } else {
        if (event.target.value.length == 2 || event.target.value.length == 5) {
          event.target.value = event.target.value + "/";
        } else if (event.target.value.length >= 10) {
          event.preventDefault()
        }
      }
      question.value = event.target.value;
    }
    if (question.controlType == "checkbox") {
      if (event.options && event.options != undefined) {
        val = event.value;
      } else {
        val = event.target.checked;
      }
    };
    if (question.controlType == "radio") {
      val = event.target.id;
    };
    if (question.controlType == "edit_grid") {
      //val = event;
      this.question[question.key] = event;
    };
    if (question.controlType == "edit_grid") {
      //val = event;
      this.question[question.key] = event;
    };
    // if (question.controlType == "inclusion-exclusion") {
    //   //val = event;
    //   debugger
    //   this.question[question.key] = event;
    // };
    if (question.controlType == "multiple-slot") {
      var item = this.form.value;
      if (question.dependents != undefined && question.dependents.length > 0) {
        question.dependents.forEach(dependent => {
          if ((dependent.expression != undefined && eval(dependent.expression)) || dependent.expression == undefined) {
            this.form.controls[dependent['dependent_field']].setValue(event.value);
          }
        });
      }

    };
    if (question.controlType != "monthYearPicker" && question.controlType != "multiple-slot" && question.controlType != "pullable" && question.controlType != "pushable" && question.controlType != "checkbox" && question.controlType != "edit_grid" && question.controlType != "radio" && question.controlType != "searchselect" && question.controlType != "countrymobno" && question.controlType != "inputSearch" && question.controlType != "daterangepicker" && question.controlType != "taginput" && question.controlType != "fileuploader" && question.controlType != "fingerprint" && question.controlType != "imageEditor" && question.controlType != "rating" && question.controlType != 'editgrid' && question.controlType != 'html-editor' && question.controlType != 'annotation' && question.controlType != 'timepicker' && question.controlType != 'button' && question.controlType != 'annotation' && question.controlType != 'range-slider' && question.controlType != 'tickets' && question.controlType != "signature") {
      val = event.target.value;
      // if(val && question.pattern && !new RegExp(question.pattern).test(val)) {
      //   this.form.controls[question.key].setErrors({'incorrect': true});
      // }else if(val && question.pattern && new RegExp(question.pattern).test(val)){
      //   this.form.controls[question.key].setErrors(null);
      // }
    };
    if (question.populate_field) {
      val = question.options[event.target.selectedIndex - 1] ? question.options[event.target.selectedIndex - 1] : "";
    }
    /**
     * for search select
     */
    if (question.controlType == "searchselect" && question.dependents != undefined && question.dependents && question.defaultsetting != undefined && question.defaultsetting.singleSelection != undefined && !question.defaultsetting.singleSelection) {
      val = this.form.controls[question.key].value;
    }
    if (question.controlType == "searchselect" && question.dependents != undefined && question.dependents && question.defaultsetting != undefined && question.defaultsetting.singleSelection != undefined && question.defaultsetting.singleSelection) {

      if (question.options && event != "") {
        let key = question.getterKey;
        val = question.options.find(x => x[key] == event.id);
      } else {
        val = "";//single selection when item is removed
      }
    }
    /** 
* for input search 
*/
    if (question.controlType == "inputSearch") {
      val = event;
    }
    if (question.controlType == "range-slider" || question.controlType == "pushable" || question.controlType == "pullable" || question.controlType == "html-editor" || question.controlType == "timepicker" || question.controlType == "annotation") {
      val = event;
      question.value = event;
    }
    if (event != undefined && question.controlType == 'signature') {
      val = event;
      question.value = event;
      this.form.controls[question.key].setValue(event);
    }
    if (event != undefined && (question.controlType == 'text-entry-question' || question.controlType == 'single-choice-question')) {
      // val = event.target.value;
      question.value = event.target.value;
      this.form.controls[question.key].setValue(question.value);
    }
    if (event != undefined && question.controlType == 'fingerprint') {
      // val = event.target.value;
      question.value = event;
      // this.form.controls[question.key].setValue(question.value);
    }
    if (event != undefined && question.controlType == 'imageEditor') {
      // val = event.target.value;
      question.value = event;
      // this.form.controls[question.key].setValue(question.value);
    }
    if (event && question.controlType == 'fileuploader' && event.documentName && this.form && this.form.controls) {
      // The uploaded file's name goes to `document_name` unless the question names its own field -
      // a form that titles one specific upload (a birth certificate, say) has no such control.
      let documentNameField = question.document_name_field ? question.document_name_field : 'document_name';
      if (this.form.controls[documentNameField]) {
        this.form.controls[documentNameField].setValue(event.documentName);
      }
    }
    if (question.controlType != "daterangepicker")
      this.commonService.setManualChange(true);
    if (question.dependents != undefined && question.dependents.length) {
      this.updateDependentValue(val);
    } else {
      if(event && event.fileSize){
        this.question['fileSize'] = event.fileSize
      }
      this.valueChanged.emit({ val: val, question: this.question });
    };
    if (question.controlType == "monthYearPicker") {
      this.valueChanged.emit({ val: event, question: this.question });
    }
  }

  emitDataOnCustomButton() {
    this.customButtonEventFired.emit(true)
  }
  updateDependentValue(val) {
    this.valueChanged.emit({ val: val, question: this.question, index: this.index });
  }
  /**************************Event thats fire on multi Drop down event  ***************************/
  onItemSelect(item: any) {
    console.log("Selected value", item);
    var isManual = false;
    if (item.isManual != undefined) {
      isManual = item.isManual;
      delete item.isManual;
    }
    this.MultiDropDownService.shareMultiDropDownData(item);
    this.setManualChange(this.question, isManual);
    this.valueChange(item, this.question, isManual);
  }
  onItemDeSelect(item: any) {
    this.MultiDropDownService.shareMultiDropDownData(item);
    this.setManualChange(this.question, true);
    this.valueChange(item, this.question);
  }
  onSelectAll(items: any) {
    this.MultiDropDownService.shareMultiDropDownData(items);
    this.setManualChange(this.question, true);
    this.valueChange(items, this.question);
  }
  onDeSelectAll(items: any) {
    this.MultiDropDownService.shareMultiDropDownData(items);
    this.setManualChange(this.question, true);
    this.valueChange(items, this.question);
  }
  setManualChange(question, status) {
    if (status && question) {
      question['_manualChange'] = status;
      if (!this.formService.blocksChange.includes(question.block_id)) {
        this.formService.blocksChange.push(question.block_id);
      }
      console.log("Blocks Change ", this.formService.blocksChange);
      this.formService.setBlocksChange(this.formService.blocksChange);
      if (question.macro_datasource) {
        let value = event.target['innerHTML'].trim();
        this.macroChangeEvent(value);
      }
    }
  }

  onDropDownClose() {
    //console.log('dropdown closed from question compo');
    this.multiselectClose.emit()
  }

  openDropDownObjectPopup(question) {

  }

  handleSearchSelect($event) {
    if ($event.target.classList.contains("searchselect-input")) {
      if ($event.keyCode == '40') {
        jQuery($event.target).find('.multiselect-dropdown-click').trigger('click')
      } else if (($event.keyCode >= 48 && $event.keyCode <= 57) || ($event.keyCode >= 65 && $event.keyCode <= 90)) {
        jQuery($event.target).find('.multiselect-dropdown-click').trigger('click');
        setTimeout(() => {
          if (jQuery($event.target).find('.filter-textbox-input').length) {
            jQuery($event.target).find('.filter-textbox-input').val($event.key);
            jQuery($event.target).find('.filter-textbox-input')[0].dispatchEvent(new Event("input", { bubbles: true }));
          }
        }, 50);
      }
    } else if ($event.target.classList.contains("focus_li_multiselect")) {
      if (($event.keyCode >= 48 && $event.keyCode <= 57) || ($event.keyCode >= 65 && $event.keyCode <= 90)) {
        if (jQuery($event.target).parent().parent().find('.filter-textbox-input').length) {
          jQuery($event.target).parent().parent().find('.filter-textbox-input').val($event.key);
          jQuery($event.target).parent().parent().find('.filter-textbox-input')[0].dispatchEvent(new Event("input", { bubbles: true }));
          jQuery($event.target).parent().parent().find('.filter-textbox-input')[0].focus();
        }
      }
    } else if ($event.target.classList.contains("filter-textbox-input")) {
      if ($event.keyCode == 40) {
        if (jQuery($event.target).parent().parent().find('.filter-textbox-input').length) {
          setTimeout(() => {
            jQuery(jQuery($event.target).parents('.dropdown-list').find('.dropdown-list-item-container')[0]).focus()
          }, 50);
        }
      }
    }
  }
  /**
   * 
   * we could have support of more type of events here instead of adding more output events
   */
  getDataFn(data: any) {
    if (data.type == "form" || data.type == "mapping") {
      this.getData.emit(data);
    }
  }

  trimValue(question) {
    if (this.form.controls != undefined && this.form.controls[question.key] != undefined && this.form.controls[question.key].value != "") {
      let val = this.form.controls[question.key].value.trim();
      const emojiRegex = /[\p{Extended_Pictographic}]/gu;
      if (emojiRegex.test(val)) {
        val = val.replace(emojiRegex, '');
        this.form.controls[question.key].setValue(val);
      }
      if (!question.additional_space && this.form.controls[this.question.key]['question_component'] && this.form.controls[this.question.key]['question_component'].question && this.form.controls[this.question.key]['question_component'].question.controlType != 'textarea') {
        const cleanedText = val.replace(/\s+/g, ' ');
        this.form.controls[question.key].setValue(cleanedText);
      }else{
        this.form.controls[question.key].setValue(val);
      }
    }
  }
  
  trackById(index: number, item) {
    return item;
  }
  ngDoCheck() {
    // console.log("ngdocheck formQuestion");
  }

  appendFieldsToForm(event) {
    console.log(event);
    if(event){
      this.formService['config'].template_selection = true;
    }else
      this.formService['config'].template_selection = undefined;
    this.runTimeQuestions.emit(event)
  }

  addToFav(question){
    if(this.config.add_fav == undefined || !this.config.add_fav){
      if(!this.form.controls.fav_templateId?.['question_component']?.question?.options){
        let datasource = this.form.controls.fav_templateId['question_component'].question.datasource;
        datasource.args = this.formService.baseService.buildDyanamicStr(datasource.args, this.formService.cardData)
        this.formService.getDictionary(datasource.resource, datasource.query_id, datasource.application, datasource.args)
          .subscribe(
            (data) => {
              this.form.controls.fav_templateId['question_component'].question.options = data;
            });
      }
      this.config.add_fav = true;
    }else{
      this.config.add_fav = false;
    }
    this.setConfig.emit({'config':this.config});
  }

  setPosition(el, q) {
    // if (q.value == '' || q.value == undefined || q.value == 0)
    //   jQuery("td.today").removeClass("active");
    let e = el.target.getBoundingClientRect().bottom;
    if (window.innerHeight - el.target.getBoundingClientRect().bottom < 170) {
      this.question.position = (this.insideGrid != undefined && this.insideGrid || this.question.singleDatePicker == false) ? 'down' : 'up';
    }
    else {
      this.question.position = 'down';
    }
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.pickerDirective = null;
    // Fix — clear question_component reference from FormControl
    if (this.form && this.form.controls && this.question && this.question.key && 
        this.form.controls[this.question.key]) {
      this.form.controls[this.question.key]['question_component'] = null;
    }
  }
  getToolTip(question) { // tooltip on numberbox
    if (question && question.hasOwnProperty('tooltip_key') && question.tooltip_key != "") {
      try {
        if (this.form && this.form.controls && this.form.controls[question.tooltip_key] && this.form.controls[question.tooltip_key].value) {
          this.tooltip_value = this.form.controls[question.tooltip_key].value;
          return true
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    }
  }
  textToSpeech(key: any, disabled: any, form_key:any,htmlEditor:boolean=false) {
    if (disabled) { return }
    let popobj = { data: { 'speech': true}, size: DialogModalSize.Sm, 'title': 'vtotext' };
    this.dialogService.open(TextToSpeechComponent, popobj).afterClosed.subscribe((result: any) => {
      if (result) {
        if(result.includes("\n") && htmlEditor && result.length>1){
         result = result.split("\n").map((x,index)=>result.split("\n").length-1!=index?x+"<br/>":x+"").join("\n");
        }
        let value_key: any = document.getElementById(key);
        let final_value = "";
        if(htmlEditor) {
          final_value = this.form.controls[form_key].value?this.form.controls[form_key].value+" "+result: result;
        }else if(value_key.value && value_key.type != "number" ){
          final_value = value_key.value+" "+result
        }else{
          final_value = result;
        }
        value_key.value = final_value
        this.form.controls[form_key].setValue(final_value);
        this.form.controls[form_key].markAsDirty();
        this.form.controls[form_key].updateValueAndValidity();
      }
    })
  }

  checkExpression(exp) {
    try {
      let item = this.form.value;
      return eval(exp);
    } catch (error) {

    }


  }

  checkConditionforError(condition: any): boolean {
    return condition.controlType == "date" ? false : true;
  }

  // currencyPattern(){
  //   let value:any = 3;
  //   if(this.formService.appService._currentSessionData.currency_decimal_limit){
  //     value = this.formService.appService._currentSessionData.currency_decimal_limit
  //   }
  //   // if(this.formService.appService.getAccountConfigValue('currency_decimal')){
  //   //   value = this.formService.appService.getAccountConfigValue('currency_decimal')
  //   // }
  //   return "^[0-9]{1,11}(?:\.[0-9]{1,"+value+"})?$"
  // }

  paginate(event) {
    event.stopPropagation();
    event.preventDefault();
  }
}
